import { useMemo } from "react";
import { ColumnDef } from "@tanstack/react-table";
import { formatNumber } from "@/lib/utils/formatters";
import { CostItem } from "@/types/costs";

export function useInvoiceSpecificationCostsColumnOverrides(): Record<
  string,
  ColumnDef<CostItem, unknown>
> {
  return useMemo(
    () => ({
      amount: {
        id: "amount",
        accessorKey: "amount",
        cell: ({ getValue }) => formatNumber(getValue() as number),
      },
    }),
    [],
  );
}
